import * as React from "react";
const SvgFiBrandsCreativeCommonsSampling = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g
      fill="#151A2D"
      fillRule="evenodd"
      clipPath="url(#fi-brands-creative-commons-sampling_svg__a)"
      clipRule="evenodd"
    >
      <path d="M12.516 2.16q4.255 0 7.228 2.88 3.003 2.85 3.003 6.96 0 4.14-2.94 6.87-3.1 2.94-7.291 2.94-4.194 0-7.228-2.91-3.036-2.91-3.035-6.9T5.32 5.04q2.94-2.88 7.196-2.88M12.483 0Q7.29 0 3.692 3.48-.001 7.08 0 12t3.692 8.46T12.483 24q5.163 0 8.95-3.57Q25 17.04 25 12q0-5.04-3.63-8.52T12.483 0" />
      <path d="M12.747 4.687a.577.577 0 0 0-.585.529l-.257 4.051-.217-3.208a.576.576 0 0 0-.585-.526.576.576 0 0 0-.584.525l-.267 3.878-.208-2.755a.576.576 0 0 0-.58-.521.577.577 0 0 0-.588.514l-.39 4.347-.091-.591a.575.575 0 0 0-.493-.475.59.59 0 0 0-.615.315l-.664 1.339H4.409v1.125h2.584a.59.59 0 0 0 .522-.313l.542 3.543a.58.58 0 0 0 .598.48.575.575 0 0 0 .566-.514l.19-2.104.286 3.788a.576.576 0 0 0 .586.521.577.577 0 0 0 .584-.526L11.1 14.7l.24 3.55c.021.296.278.527.587.526a.576.576 0 0 0 .584-.529l.246-3.892.227 3.47c.02.295.273.525.582.527a.577.577 0 0 0 .588-.518l.23-2.838.246 3.118a.577.577 0 0 0 .582.52.577.577 0 0 0 .586-.516l.344-4.014.134 1.08a.574.574 0 0 0 .501.491.59.59 0 0 0 .622-.342l.906-2.1h2.545v-1.125h-2.936a.59.59 0 0 0-.541.347l-.199.459-.557-4.491a.58.58 0 0 0-.593-.496.576.576 0 0 0-.573.516l-.213 2.488-.263-3.329a.576.576 0 0 0-.583-.52.577.577 0 0 0-.585.519l-.176 2.176-.299-4.563a.577.577 0 0 0-.585-.527" />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-sampling_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsSampling;
